export const throwFetchError = () => {
  throw createError({
    statusCode: 500,
    fatal: true,
    statusMessage: "Failed to fetch data from backend",
  });
};

export const throwNotFound = () => {
  throw createError({ statusCode: 404, fatal: true });
};
